'use strict';
module.exports = require('../../full/instance/for-each');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/for-each.js
// module id = 595
// module chunks = 13